/** @format */

import Page from "../../components/Page";
import { Card, Container, IconButton, Stack, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import Iconify from "../../components/Iconify";
import swal from "../../reusables/CustomSwal";
import User from "../../dao/User";
import { useNavigate } from "react-router-dom";
import UserForm from "./UserForm";

export default function UserCreate() {
  const navigate = useNavigate();

  const [wabas, setWabas] = useState([]);

  const onFormSubmit = async (values) => {
    let wabaObject = wabas.map((o) => o.waba_id);
    let body = { ...values };

    if (values.role === "MEMBER" || values.role === "ADMIN") {
      if (wabaObject.length === 0)
        return swal.fire({
          title: "Error",
          text: "Please assign a WABA ID to continue.",
          icon: "error",
          showConfirmButton: true,
        });
      body = {
        ...values,
        waba_ids: wabaObject,
      };
    }
    // console.log(body);

    let popupResult = await swal.fire({
      title: "Confirm",
      text: "Are you sure to save this user?",
      icon: "question",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
    });

    if (popupResult.isConfirmed) {
      try {
        await User.create(body);
        // let queryResult = await User.create(body);
        // console.log(queryResult);
        await swal.fire({
          title: "Success",
          text: "User data is saved.",
          icon: "success",
          confirmButtonText: "Go back",
        });
        navigate(-1);
      } catch (e) {
        console.log(e);
        let errorMessage = "An error has occurred. Please try again later.";
        if (e.code === "DUPLICATE_EMAIL")
          errorMessage = "Email has already been used.";
        else if (e.code === "INVALID_EMAIL" || e.code === "MISSING_INFO")
          errorMessage = "Please re-check the user data.";
        await swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
      }
    }
  };

  const RegisterSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required."),
    last_name: Yup.string().required("Lastname is required"),
    job_title: Yup.string().required("Job Title is required."),
    email: Yup.string()
      .email("Email must be a valid email address.")
      .required("Email is required."),
    phone_number: Yup.string().required("Phone number is required."),
    role: Yup.string().required("Please select a role."),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      job_title: "",
      email: "",
      phone_number: "",
      role: "",
    },
    validationSchema: RegisterSchema,
    onSubmit: (values) => onFormSubmit(values),
  });

  return (
    <Page title="Create User">
      <Container>
        <Stack spacing={2} direction="row" sx={{ mb: 4 }}>
          <IconButton
            sx={{ p: 0, height: "100%", backgroundColor: "white" }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={22} height={22} />
          </IconButton>
          <Typography variant="h4">New User</Typography>
        </Stack>
        <Card sx={{ p: 4 }}>
          <UserForm
            formik={formik}
            mode="create"
            wabas={wabas}
            setWabas={setWabas}
          />
        </Card>
      </Container>
    </Page>
  );
}
